import React from 'react'
import { PropertyData } from '../models/properties'
import { sanitizeTags } from '../utils/string'
import Tooltip from 'rc-tooltip'

export function PropertyPath(property) {
  return `/properties/${property.slug}`
}

interface PropertyInfoProps {
  property: PropertyData
  guest: boolean
  combinedTitle?: boolean
  compact?: boolean
  actionName?: string
  onAction?: (PropertyData) => void
  newTab?: boolean
}

export class PropertyInfo extends React.Component<PropertyInfoProps, {}> {
  static get defaultProps() {
    return {
      property: {},
      guest: false,
      compact: false,
      combinedTitle: false,
      newTab: false
    }
  }

  renderPropertyName() {
    const { property, combinedTitle } = this.props

    if (combinedTitle) {
      return (
        <a href={ PropertyPath(property) }>
          <h4>{ property.name }, { property.region }</h4>
        </a>
      )
    } else {
      return (
        <a href={ PropertyPath(property) }>
          <h4>{ property.name }</h4>
        </a>
      )
    }
  }

  renderAction() {
    if (this.props.actionName) {
      return (
        <a href="javascript:void(0)"
          onClick={() => {
            this.props.onAction(this.props.property)
          }}
          className={"button expanded " + (this.props.compact ? "small" : "")}
        >
          { this.props.actionName }
        </a>
      )
    } else {
      return (
        <a href={ PropertyPath(this.props.property) }
          className={"button expanded " + (this.props.compact ? "small" : "")}
        >
          View
        </a>
      )
    }
  }

  renderPropertyTypes() {
    const { property } = this.props

    if (property.additional_property_types && property.additional_property_types.length > 0) {
      console.log(property.additional_property_types)
      const overlay = `${property.type}, ${property.additional_property_types.join(', ')}`
      return (
        <Tooltip placement="top" trigger={['hover', 'click']} overlay={<span>{ overlay }</span>}>
          <span>{ property.type } *</span>
        </Tooltip>
      )
    } else {
      return property.type
    }
  }

  renderPrice(nightly) {
    const currency = nightly.charAt(0)
    const numericalPrice = (currency == '€') || (currency == '£') || (currency == '$')

    if (this.props.guest) {
      return ""
    } else {
      if (numericalPrice) {
        return (
          <>From <strong>{ nightly }</strong>/night</>
        )
      } else {
        return nightly
      }
    }
  }

  render() {
    const { property, guest, compact, combinedTitle } = this.props

    const sleeps_extra = property.sleeps_extra && property.sleeps_extra > 0

    return (
      <div className="property-info">
        { !guest ?
          this.renderPropertyName() :
          <a href={ PropertyPath(property) }>
            <h4>{ property.region }</h4>
          </a>
        }

        { !guest && !combinedTitle && !compact ? <h5 className="property-listing-region">{ property.region }</h5> : undefined }
        
        { !compact ? <p dangerouslySetInnerHTML={{__html: sanitizeTags(property.summary) }}></p> : undefined }

        <div className="property-listing-price">
          <div>
            { this.renderPropertyTypes() }
          </div>
          <div>
            { this.renderPrice(property.price_nightly) }
          </div>
        </div>

        <div className="property-listing-tools">
          { !compact ? <ul>
            { !property.hide_bedrooms ? <li>
              { property.bedrooms_noun || "Bedrooms" } { property.bedrooms }
            </li> : undefined }
            { !property.hide_bathrooms ? <li>Bathrooms { property.bathrooms }</li> : undefined }
            { !property.hide_sleeps ? <li>Sleeps { property.sleeps }{ sleeps_extra ? '+' : '' }</li> : undefined }
          </ul> : undefined }

          { this.renderAction() }
        </div>
      </div>
    )
  }
}

interface PropertyProps {
  property: PropertyData
  infoFirst?: boolean
  guest: boolean
}

export default class Property extends React.Component<PropertyProps, {}> {
  static get defaultProps() {
    return {
      property: {},
      infoFirst: false,
      guest: false
    }
  }

  render() {
    const { property, infoFirst, guest } = this.props

    return (
      <div className="property-listing">
        { infoFirst ? <PropertyInfo property={property} guest={guest} /> : undefined }

        <a href={ PropertyPath(property) }>
          <div className={"property-listing-image " + (infoFirst ? "mg-t" : "")}>
            <img src={ property.listing_image } />

            <div className="listing-overlay">
              <h5>Click to view further details</h5>
            </div>
          </div>
        </a>
        
        { !infoFirst ? <PropertyInfo property={property} guest={guest} /> : undefined }
      </div>
    )
  }
}